import useAdministrationNamingSchemeColumns from './useSchemeDetailsColumns'

export default useAdministrationNamingSchemeColumns
